/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

export const ISO = [
  { value: "PRELIMINARY", label: "PRELIMINARY" },
  { value: "TERMINATED", label: "REMOVED" },
  { value: "NOTASSIGNED", label: "NOTASSIGNED" },
  { value: "FINAL", label: "FINAL" },
];

export const assignerHubOptions = [
  { value: "HubA", label: "HubA" },
  { value: "HubB", label: "HubB" },
  { value: "HubC", label: "HubC" },
  { value: "HubD", label: "HubD" },
  { value: "HubE", label: "HubE" },
  { value: "HubF", label: "HubF" },
  { value: "HubG", label: "HubG" },
  { value: "HubH", label: "HubH" },
  { value: "HubI", label: "HubI" },
  { value: "HubJ", label: "HubJ" },
  { value: "HubK", label: "HubK" },
  { value: "HubL", label: "HubL" },
  { value: "HubM", label: "HubM" },
  { value: "HubN", label: "HubN" },
  { value: "HubO", label: "HubO" },
  { value: "HubP", label: "HubP" },
  { value: "HubQ", label: "HubQ" },
  { value: "HubR", label: "HubR" },
  { value: "HubS", label: "HubS" },
  { value: "HubT", label: "HubT" },
  { value: "HubU", label: "HubU" },
  { value: "HubV", label: "HubV" },
  { value: "HubW", label: "HubW" },
  { value: "HubX", label: "HubX" },
  { value: "HubY", label: "HubY" },
  { value: "HubZ", label: "HubZ" },
];
